"use strict";

//pour les flèches dans le menu d'accueil (le menu DVD)
let menuList = document.querySelectorAll(".menu-list__el .link");

if (menuList) {
    for (let i = 0; i < menuList.length; i++) {
        menuList[i].addEventListener("mouseover", () => {
            for (let j = 0; j < menuList.length; j++) {
                if (j == i) {
                    menuList[j].classList.add("arrow");
                }else{
                    menuList[j].classList.remove("arrow");    
                }
            }
        });
    
        menuList[i].addEventListener("focusin", () => {
            for (let j = 0; j < menuList.length; j++) {
                if (j == i) {
                    menuList[j].classList.add("arrow");
                }else{
                    menuList[j].classList.remove("arrow");
                }
            }
        });
    }
}

//pour le menu des chapitres
let bgDarkenend = document.querySelector(".bgDarkened");
let btnChapters = document.querySelector(".btnChapitres");

if (btnChapters) {
    let menuChapters = document.querySelector(".menu-chapitres");
    let btnBackChapters = document.querySelector(".back-button--chapitres");

    btnChapters.addEventListener("click", () => {
        menuChapters.classList.add("menu-chapitres--active");
        bgDarkenend.classList.add("darkened");
    });
    
    btnBackChapters.addEventListener("click", () => {
        menuChapters.classList.remove("menu-chapitres--active");
        bgDarkenend.classList.remove("darkened");
    });
}



//pour le menu des crédits et features
let btnCredits = document.querySelector(".btnCredits");

if (btnCredits) {
    let menuCredits = document.querySelector(".menu-credits");
    let btnBackCredits = document.querySelector(".back-button--credits");


    btnCredits.addEventListener("click", () => {
        menuCredits.classList.add("menu-credits--active");
        bgDarkenend.classList.add("darkened");
    });

    btnBackCredits.addEventListener("click", () => {
        menuCredits.classList.remove("menu-credits--active");
        bgDarkenend.classList.remove("darkened");
    });
}

//pour le burger menu
if (window.innerWidth < 1024) {
    let burgerMenu = document.querySelector(".menu__burger");
    
    if (burgerMenu) {
        let menu = document.querySelector(".menu__liste");

        let menuLinks = document.querySelectorAll('.menu__el a');

        burgerMenu.addEventListener("click", () => {
            burgerMenu.classList.toggle("menu__burger--active");
            menu.classList.toggle("menu__liste--active");
        });

        menuLinks.forEach( item => {
            item.addEventListener("click", () => {
                burgerMenu.classList.toggle("menu__burger--active");
                menu.classList.toggle("menu__liste--active");
            });
        });
    } 
}

/* Scrollspy menu section */ 
//Src : https://dev.to/nikhilroy2/how-to-create-javascript-scrollspy-vanilla-js-tutorial-35o9
let menuSection = document.querySelectorAll('.menu__el');

if (menuSection) {
    menuSection.forEach(v=> {
        v.onclick = (()=> {
         setTimeout(()=> {
            menuSection.forEach(j=> j.classList.remove('menu__el--active'))
          v.classList.add('menu__el--active')
        },300)
         })
      })
      
      window.onscroll = (()=> {
        let mainSection = document.querySelectorAll('.section');
      
        mainSection.forEach((v,i)=> {
          let rect = v.getBoundingClientRect().y
          if(rect < window.innerHeight-400){
            menuSection.forEach(v=> v.classList.remove('menu__el--active'))
            menuSection[i].classList.add('menu__el--active')
          }
        })
      })
}

